module.exports = __webpack_public_path__ + "static/media/ScrubPlanBidInvite.32aadd14.png";